import React from "react";
import "../../node_modules/font-awesome/css/font-awesome.min.css";
import { Link } from "react-router-dom";
import logo from "../assets/images/Artwork-Specific-Edition-Page-Auction/user-profile-icon-1.png";
import editIcon from "../assets/images/account-info/edit-profile-pic-icon.svg";
import img from "../assets/images/landing-page/collection-banner-carousel--collection-cover-art.png";
import plusIcon from "../assets/images/account-info/add-social-media-icon.svg";
import card1 from "../assets/images/Collection/artwork-1.png";
import card2 from "../assets/images/Collection/artwork-2.png";
import card3 from "../assets/images/Collection/artwork-3.png";

const Review = ({
  prevStep,
  nextStep,
  handleChange,
  values,
  submit,
  goToStep,
}) => {
  const Previous = (e) => {
    e.preventDefault();
    prevStep();
  };

  const GoToStep = (index) => {
    // e.preventDefault();
    goToStep(index);
  };

  const getImageAsData = (image) => {
    return URL.createObjectURL(image);
  };

  return (
    <div className="main-wrapper">
      {/* Header area start */}
      <nav className="navbar navbar-light justify-content-between">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="logo" /> Lorem
        </Link>
        <div className="justify-content-between">
          {/* <Link to="#"><i className="fa fa-search" aria-hidden="true"></i></Link>&emsp;
                    <Link to="/Drops">Drops</Link>&emsp;
                    <Link to="/Marketplace">Marketplace </Link> */}
          <div className="dropdown">
            <button className="dropbtn">
              <i className="fa fa-user" aria-hidden="true"></i>
            </button>
            <div className="dropdown-content text-left">
              <Link to="/AccountInfo">Account Info</Link>
              <Link to="#">Account Activity</Link>
              <Link to="#">Connect Wallet</Link>
              <Link to="/UserProfileBuyer">Buyer Profile</Link>
              <Link to="/CollectionDetails">Add New Collections</Link>
              <Link to="/LoginSignup">Login</Link>
            </div>
          </div>
        </div>
      </nav>
      {/* Header area end */}

      {/* Form area start */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center form-area">
            <h1 className="text-center">Submit New Collection</h1>

            {/* Progressbar start */}
            <ul id="progress-bar" className="progressbar">
              <li className="active">COLLECTION</li>
              <li className="active">UPLOAD ITEMS</li>
              <li className="active">ITEM DETAILS</li>
              <li className="active">REVIEW & SUBMIT</li>
            </ul>
            {/* Progressbar end */}
          </div>
        </div>
      </div>

      {/* multistep form start*/}
      <div className="container text-center margin-70 arrow">
        <button onClick={Previous}>&#10229;</button>
        <h1>Review & Submit</h1>
        {/* <button><Link to="/Submitted">Submit</Link></button>                 */}
        <button onClick={submit}>Submit</button>
      </div>
      <div className="container mb-5 text-center">
        <div className="row justify-content-center">
          <div className="col-lg-8 review-area">
            <h1>Collection Title</h1>
            {/* <h6>Lorem ipsum dolor sit amet, consectetuer</h6> */}
            <h6>{values.collectionTitle}</h6>
            <h1>Description</h1>
            <p>{values.collectionDescription.length} of 1000 characters used</p>
            <h6>{values.collectionDescription}</h6>
            <h4>
              Collection Cover Art{" "}
              <img src={editIcon} onClick={() => GoToStep(0)} alt="" />{" "}
            </h4>
            <img
              src={values.collectionCoverSrc}
              alt=""
              className="review-banner"
            />
            <h4>
              {values.items.length} Items in this Collection{" "}
              <img src={plusIcon} onClick={() => GoToStep(1)} alt="" />{" "}
            </h4>
          </div>
        </div>
        <div className="row review-card justify-content-center">
          {values.items.map((item, index) => {
            return (
              <div key={index} className="card text-left">
                <img
                  src={getImageAsData(item.image)}
                  className="card-img-top"
                  alt=""
                />
                <div className="card-body">
                  <h3>{values.collectionTitle}</h3>
                  <strong>Artist Name</strong>
                  <h6 className="card-text">
                    <small>{item.edition} Editions</small>
                  </h6>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {/* multistep form end*/}
      {/* Form area end */}
    </div>
  );
};

export default Review;
